import { useCallback, useEffect, useState } from 'react';
import type { AdminFinanceStats } from '../../../domain/superadmin/types';
import { useAppContext } from '../../../contexts/AppContext';
import { fetchAdminFinanceStats } from '../../../services/modules/superadmin/superadminApi';
import { SuperadminApiError } from '../../../services/modules/superadmin/errors';
import { notify } from '../../../utils/toast';

export function useAdminFinanceStats() {
  const [data, setData] = useState<AdminFinanceStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { setCurrentPage } = useAppContext();

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const stats = await fetchAdminFinanceStats();
      setData(stats);
    } catch (e) {
      if (e instanceof SuperadminApiError && e.isForbidden) {
        setCurrentPage('dashboard');
        notify.warning('Acesso não autorizado à área de superadmin.');
        return;
      }
      setError(e instanceof Error ? e.message : 'Erro ao carregar financeiro');
    } finally {
      setIsLoading(false);
    }
  }, [setCurrentPage]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, isLoading, error, refetch: load };
}
